// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Icon from '@ant-design/icons';

import Modal from 'antd/lib/modal';

import { LoupeIcon } from 'icons';
import CVATTooltip from 'components/common/cvat-tooltip';
import { Job } from 'cvat-core/src/session';
import { LogType } from 'cvat-core/src/enums';

interface Props {
    jobInstance: Job;
    frame: number;
    disabled: boolean;
}

function ConfirmFrameInspectionControl(props: Props): JSX.Element {
    const {
        jobInstance, frame, disabled,
    } = props;

    return (
        disabled ? (
            <Icon component={LoupeIcon} className='cvat-confirm-frame-inspection-control cvat-disabled-canvas-control' />
        ) : (
            <CVATTooltip title='完成图片质检' placement='right'>
                <Icon
                    component={LoupeIcon}
                    className='cvat-confirm-frame-inspection-control'
                    onClick={(): void => {
                        Modal.confirm({
                            title: '确认完成当前图片质检',
                            content: '已经仔细确认过当前图片合乎标注规范要求。是否继续？',
                            className: 'cvat-modal-confirm-frame-inspection',
                            onOk: () => {
                                Promise.all([jobInstance.logger.log(LogType.createConfirmation, {
                                    obj_name: 'frame:inspection',
                                    obj_id: frame,
                                })]).then((result) => {
                                    console.log(result);
                                });
                            },
                            okButtonProps: {
                                type: 'primary',
                                danger: true,
                            },
                            okText: '确认',
                            cancelText: '取消',
                        });
                    }}
                />
            </CVATTooltip>
        )
    );
}

export default React.memo(ConfirmFrameInspectionControl);
